module.exports = __webpack_public_path__ + "assets/currentLocation-9826df.svg";